export default {"src":"/_next/static/media/qrcode-circle-fill.7d7aa898.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};